import _ from 'lodash';
import { ControlType, Item } from '../../workspaces/item';
import Workspace from '../../workspaces';
import templates from '../templates';
import ColorFlatUI from '../tools/colorflatui';

const textStyle = (() => {
    let _visible = false;
    let $dialog = null;
    let $template = null;
    const idTextStyle = '#dialog-text-style';
    const eventCloseName = 'dialog-text-style-close';

    const _close = () => $dialog.close();

    const _onClose = () => {
        Workspace.addAction(new Item(eventCloseName, '', ControlType.GlobalEvent));
        _visible = false;
        $dialog.destroy();
        $template.remove();
    };

    return (name, style) => {
        if (_visible) { _close(); }

        _visible = true;

        let dataSource;
        const options = style.options;
        const canClearTagStyles = _.isFunction(style.clearTagStyles);

        $template = $(templates('dialog-text-style', _.assign({}, options, { showClearTagStyles: canClearTagStyles })));

        const onChange = (type, value) => {
            switch (type) {
            case 'background':
                switch (Number(value)) {
                case 0:
                    options.box = false;
                    options.colorize = false;
                    break;
                case 1:
                    options.box = true;
                    options.colorize = false;
                    break;
                case 2:
                    options.box = true;
                    options.colorize = true;
                    options.color = '#000000';
                    break;
                }
                break;
            case 'size':
                options.size = Number(value);
                break;
            case 'color':
                options.color = value;
                break;
            case 'bold':
                options.bold = value;
                break;
            case 'italic':
                options.italic = value;
                break;
            case 'offsetX':
                options.offsetX = value;
                break;
            case 'offsetY':
                options.offsetY = value;
                break;
            }

            style.change(options);
        };

        dataSource = [
            { text: '8', value: 8 },
            { text: '9', value: 9 },
            { text: '10', value: 10 },
            { text: '11', value: 11 },
            { text: '12', value: 12 },
            { text: '14', value: 14 },
            { text: '16', value: 16 },
            { text: '18', value: 18 }
        ];

        $template.find('select[name="size"]').kendoDropDownList({
            dataTextField: 'text',
            dataValueField: 'value',
            dataSource,
            index: _.findIndex(dataSource, (d) => d.value === options.size),
            change: (e) => {
                onChange('size', e.sender.value());
                Workspace.addAction(new Item(`${idTextStyle} select[name="size"]`, e.sender.value(), ControlType.KendoDropDownList));
            }
        });

        dataSource = [
            { text: 'Transparente', value: 0 },
            { text: 'Branco', value: 1 },
            { text: 'Colorido', value: 2 }
        ];

        $template.find('select[name="background"]').kendoDropDownList({
            dataTextField: 'text',
            dataValueField: 'value',
            dataSource,
            index: (() => {
                if (options.box && options.colorize) {
                    return 2;
                } else if (options.box) {
                    return 1;
                }
                return 0;
            })(),
            change: (e) => {
                onChange('background', e.sender.value());
                Workspace.addAction(new Item(`${idTextStyle} select[name="background"]`, e.sender.value(), ControlType.KendoDropDownList));
            }
        });

        const _colorCanvas = (theme) => {
            const canvas = document.createElement('canvas');
            canvas.width = 44;
            canvas.height = 34;
            const ctx = canvas.getContext('2d');
            _.forEach(theme, (c, i) => {
                ctx.beginPath();
                const x = (i * canvas.width) / theme.length;
                const y = 0;
                ctx.rect(x, y, canvas.width / theme.length, canvas.height);
                ctx.fillStyle = c;
                ctx.fill();
            });
            return canvas.toDataURL('image/png');
        };

        dataSource = _(ColorFlatUI)
            .transform((result, theme, text) => {
                if (_.isObject(theme)) {
                    _.forEach(theme, (colors, range) =>
                        result.push({
                            'text': text,
                            'value': colors[0],
                            'template': _colorCanvas(colors)
                        })
                    );
                }
            }, [{
                'text': 'black',
                'value': 'auto',
                'template': _colorCanvas(['#000'])
            }])
            .value();

        $template.find('select[name="color"]').kendoDropDownList({
            dataTextField: 'text',
            dataValueField: 'value',
            valueTemplate: `<img style="height: 27px; margin: -2px 0 0 -8px;" src="#: data.template #">`,
            template: `<img style="margin: 0 0 0 -5px" src="#: data.template #">`,
            dataSource,
            index: (options.color ? _.findIndex(dataSource, (d) => d.value === options.color) : 0),
            change: (e) => {
                onChange('color', e.sender.value());
                Workspace.addAction(new Item(`${idTextStyle} select[name="color"]`, e.sender.value(), ControlType.KendoDropDownList));
            }
        });

        $template.find('input[name="bold"]').on('change', (e) => {
            onChange('bold', e.target.checked);
            Workspace.addAction(new Item(`${idTextStyle} input[name="bold"]`, e.target.checked, ControlType.InputCheckbox));
        });

        $template.find('input[name="italic"]').on('change', (e) => {
            onChange('italic', e.target.checked);
            Workspace.addAction(new Item(`${idTextStyle} input[name="italic"]`, e.target.checked, ControlType.InputCheckbox));
        });

        $template.find('input[name="offsetX"]').on('change', (e) => {
            onChange('offsetX', Number(e.target.value));
            Workspace.addAction(new Item(`${idTextStyle} input[name="offsetX"]`, Number(e.target.value), ControlType.Input));
        });

        $template.find('input[name="offsetY"]').on('change', (e) => {
            onChange('offsetY', Number(e.target.value));
            Workspace.addAction(new Item(`${idTextStyle} input[name="offsetY"]`, Number(e.target.value), ControlType.Input));
        });

        if (canClearTagStyles) {
            $template.find('button[name="clearTagStyles"]').on('click', () => {
                style.clearTagStyles();
                Workspace.addAction(new Item(`${idTextStyle} button[name="clearTagStyles"]`, '', ControlType.GlobalEvent));
                _close();
            });
        }

        $dialog = $template.kendoWindow({
            width: '540px',
            resizable: false,
            draggable: true,
            visible: false,
            title: '',
            appendTo: 'body',
            close: _onClose
        }).data('kendoWindow');

        $(document).off(eventCloseName);
        $(document).on(eventCloseName, _onClose);

        $dialog.center().open();

        return $dialog;
    };
})();

export default textStyle;



// WEBPACK FOOTER //
// ./src/scripts/core/dialog/text-style.js